import TripsSvgComponent from "@assets/svg-components/dashboard/trips";
import DownloadSvgComponent from "@assets/svg-components/download";
import { getColorStyle, getSingleColor } from "@common/color";
import { convertCurrentDate, convertDate } from "@common/date-helpers";
import {
  concatString,
  formatAmount,
  formatText,
  getFirstLetterOfEachString,
} from "@common/text-helpers";
import ProfileCircle from "@components/ProfileCircle";
import { getValue } from "@utils/lodash";
import { Tooltip } from "react-tooltip";

function TripsTable(props: any) {
  // Function to get dynamic approval status label
  const getDynamicApprovalStatusLabel = (item: any) => {
    const approvalStatus = getValue(item, `approval_status`, "");
    
    if (approvalStatus !== "awaiting_approval") {
      return { mainLabel: formatText(approvalStatus), subLabel: "" };
    }

    const tripApprovers = getValue(item, `trip_approvers`, []);
    
    if (tripApprovers.length === 0) {
      return { mainLabel: formatText(approvalStatus), subLabel: "" };
    }

    // Filter approvers with awaiting_approval status
    const awaitingApprovers = tripApprovers.filter((approver: any) => 
      getValue(approver, `approval_status`, "") === "awaiting_approval"
    );

    if (awaitingApprovers.length === 0) {
      return { mainLabel: formatText(approvalStatus), subLabel: "" };
    }

    const sortedApprovers = awaitingApprovers.sort((a: any, b: any) => {
      const levelA = getValue(a, `approval_level`, 0);
      const levelB = getValue(b, `approval_level`, 0);
      return levelA - levelB;
    });

    const firstApprover = sortedApprovers[0];
    const approvalType = getValue(firstApprover, `approval_type`, "").toLowerCase();

    let subLabel = "";
    switch (approvalType) {
      case "submits_to":
        subLabel = "Reporting Manager";
        break;
      
      case "project_head":
        subLabel = "Project Head";
        break;

      case "manual_approver":
        subLabel = "Manual Approver";
        break;
      
      case "department_head_logged_in_user":
        const departmentName = getValue(firstApprover, `approver.department.department_name`, "");
        subLabel = departmentName ? `${departmentName} Team` : "Department Head";
        break;
      
      default:
        subLabel = "";
    }

    return { mainLabel: "Awaiting Approval", subLabel };
  };

  return (
    <div>
      <div>
        <table className="datatable_table">
          <thead className="datatable_table_thead">
            <th className="datatable_table_th" style={{ width: "70px" }}>
              {/* <label
                className="m-0 position-relative"
                htmlFor="header-checkbox"
              >
                <input
                  type="checkbox"
                  className="default-checkbox"
                  id="header-checkbox"
                  onChange={() =>
                    props.handleCheckAll(
                      getValue(props, `list.length`, 0) ===
                        getValue(props, `selectedIDs.length`, 0)
                        ? "All"
                        : "None"
                    )
                  }
                  checked={
                    getValue(props, `list.length`, 0) > 0 &&
                    getValue(props, `list.length`, 0) ===
                      getValue(props, `selectedIDs.length`, 0)
                  }
                />
                <div className="custom-checkbox">
                  <img
                    src="/images/uploaded-details/tick.svg"
                    className="img-fluid uploaded-tick"
                  />
                </div>
              </label> */}
              {/* <TripsSvgComponent /> */}
            </th>
            <th className="datatable_table_th">
              <h6 className="">Trip No</h6>
              <p className="small_text">Submitted On</p>
            </th>
            <th className="datatable_table_th">
              <h6 className="">Trip Details</h6>
              <p className="small_text">Travel Type</p>
            </th>
            <th className="datatable_table_th">
              <h6 className="">Total Amount</h6>
            </th>
            <th className="datatable_table_th">
              <h6 className="">Submitted by</h6>
            </th>
            <th className="datatable_table_th">
              <h6 className="">Current Approver</h6>
            </th>
            <th className="datatable_table_th">
              <h6 className="">Status</h6>
            </th>
            <th className="datatable_table_th">
              <h6 className="">Action</h6>
            </th>
          </thead>
          <tbody className="datatable_table_tbody">
            {getValue(props, `list`, []).map((item: any, index: number) => {
              console.log(item, "item");
              const statusLabels = getDynamicApprovalStatusLabel(item);
              
              return (
                <tr key={index} className="datatable_table_tr">
                  <td className="datatable_table_td" style={{ width: "70px" }}>
                    {/* <label
                      className="m-0 position-relative"
                      htmlFor={`header-checkbox-${index}`}
                    >
                      <input
                        type="checkbox"
                        className="default-checkbox"
                        id={`header-checkbox-${index}`}
                        onChange={() =>
                          props.handleCheckUsers(getValue(item, `id`, ""))
                        }
                        checked={getValue(props, `selectedIDs`, []).includes(
                          getValue(item, `id`, "")
                        )}
                      />
                      <div className="custom-checkbox">
                        <img
                          src="/images/uploaded-details/tick.svg"
                          className="img-fluid uploaded-tick"
                        />
                      </div>
                    </label> */}
                    <TripsSvgComponent
                      color={getSingleColor(
                        getValue(item, `approval_status`, "")
                      )}
                      size={20}
                    />
                  </td>
                  <td
                    className="datatable_table_td align-items-center"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                  >
                    <div className="d-flex">
                      <div>
                        <h6 className=" color_primary">
                          {getValue(item, `trip_id`, "")}
                        </h6>{" "}
                        <p className="small_text">
                          {/* {convertDate(getValue(item, `submitted_at`, ""))} */}
                          {convertCurrentDate(
                            getValue(item, `submitted_at`, "")
                          )}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td
                    className="datatable_table_td align-items-center"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                  >
                    <div className="d-flex">
                      <div>
                        <h6 className="">{getValue(item, `trip_name`, "")}</h6>
                        <p className="small_text">
                          {/* {convertDate(getValue(item, `submitted_at`, ""))} */}
                          {formatText(getValue(item, `travel_type`, ""))}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td
                    className="datatable_table_td"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                  >
                    {parseFloat(getValue(item, `total`, "")) ? (
                      <h6
                        className={` ${
                          parseInt(getValue(item, `total`, 0)) < 0
                            ? "color_danger"
                            : ""
                        }`}
                      >
                        {getValue(item, `claimed_currency_symbol`, "")}{" "}
                        {formatAmount(getValue(item, `total`, ""))}
                      </h6>
                    ) : (
                      <p className="ms-4">-</p>
                    )}
                  </td>
                  <td
                    className="datatable_table_td"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                  >
                    {getValue(item, `created_by.email`, "") ? (
                      <div className="d-flex align-items-center">
                        <ProfileCircle
                          name="created_by"
                          item={item}
                          value={getValue(item, `created_by.first_name`, "")}
                        />
                        <div>
                          <h6>
                            {" "}
                            {getValue(item, `created_by.first_name`, "")}{" "}
                            {getValue(item, `created_by.middle_name`, "")}{" "}
                            {getValue(item, `created_by.last_name`, "")}
                          </h6>
                          <p>{getValue(item, `created_by.email`, "")}</p>
                        </div>
                      </div>
                    ) : (
                      <p className="text-center ms-5">-</p>
                    )}
                  </td>
                  <td
                    className="datatable_table_td"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                  >
                    {getValue(item, `current_approver.email`, "") ? (
                      <div className="d-flex align-items-center">
                        <ProfileCircle
                          name="current_approver"
                          item={item}
                          value={getValue(
                            item,
                            `current_approver.first_name`,
                            ""
                          )}
                        />
                        <div>
                          <h6 className={``}>
                            {getValue(item, `current_approver.first_name`, "")}{" "}
                            {getValue(item, `current_approver.middle_name`, "")}{" "}
                            {getValue(item, `current_approver.last_name`, "")}
                          </h6>
                          <p className="small_text">
                            {getValue(item, `current_approver.email`, "")}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <p className="text-center ms-5">-</p>
                    )}
                  </td>
                  <td
                    className="datatable_table_td"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                    style={{ minWidth: "180px" }}
                  >
                    <div>
                      <h6
                        className=""
                        style={{
                          ...getColorStyle(getValue(item, `approval_status`, "")),
                          whiteSpace: "nowrap",
                          lineHeight: "1.3",
                          fontSize: "0.875rem"
                        }}
                      >
                        {statusLabels.mainLabel}
                      </h6>
                      {statusLabels.subLabel && (
                        <p className="small_text ms-2">
                          {statusLabels.subLabel}
                        </p>
                      )}
                    </div>
                  </td>
                  <td className="datatable_table_td">
                    <div className="d-flex align-items-center">
                      <div
                        data-tooltip-id={"my-tooltip-trip-download"}
                        data-tooltip-content={
                          getValue(props, "downloadingTripId", null) ===
                          getValue(item, "id", "")
                            ? "Preparing download..."
                            : "Download"
                        }
                        className={
                          getValue(props, "downloadingTripId", null) ===
                          getValue(item, "id", "")
                            ? "pe-none opacity-75"
                            : "cursor-pointer"
                        }
                        onClick={() => {
                          if (
                            getValue(props, "downloadingTripId", null) !==
                            getValue(item, "id", "")
                          ) {
                            props.handleDownload(getValue(item, `id`, ""));
                          }
                        }}
                      >
                        {getValue(props, "downloadingTripId", null) ===
                        getValue(item, "id", "") ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary"
                            role="status"
                            aria-label="Preparing download"
                          />
                        ) : (
                          <DownloadSvgComponent color={"lightgray"} size={20} />
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Tooltip id="my-tooltip" />
      <Tooltip id="my-tooltip-trip-download" place="bottom" />
    </div>
  );
}

export default TripsTable;
